var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showTask ? _c('div', {
    staticClass: "time-task",
    on: {
      "click": _vm.clickTask
    }
  }, [_c('circleProgress', {
    ref: "progressRef",
    staticClass: "progress-ring-circle",
    attrs: {
      "current-time": _vm.currentTime,
      "duration": _vm.duration,
      "stroke-width": _vm.strokeWidth,
      "layer-stroke-width": 68,
      "r": 20,
      "size": {
        width: 46,
        height: 45
      },
      "layer-color": _vm.layerColor,
      "color": {
        '0%': '#ffbb01',
        '100%': '#ffbb01'
      }
    },
    on: {
      "complete": _vm.onComplete
    }
  }), _vm.showTipImg ? _c('div', [_vm.isLogin ? _c('img', {
    staticClass: "reward-img",
    attrs: {
      "src": "https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/redpocketshake-2.png"
    }
  }) : _c('img', {
    staticClass: "reward-img",
    attrs: {
      "src": "https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/redpocketshakeshake-2.png"
    }
  })]) : _vm.isTaskDone ? _c('img', {
    staticClass: "reward-img",
    attrs: {
      "src": "https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/getrewardall_detail.png",
      "alt": ""
    }
  }) : _vm.visiableLottery ? _c('img', {
    staticClass: "reward-img",
    attrs: {
      "src": "https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/getreward-2.png",
      "alt": ""
    }
  }) : _c('div', {
    staticClass: "img-bg",
    style: _vm.imgBgStyle
  }), _vm.taskText && _vm.visiableLottery || _vm.isTaskDone || _vm.showTipImg ? _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.taskText) + " ")])]) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };